import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { DialogService, DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { AuthenticationService } from '@app/core/authentication/services/authentication.service';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gc-dialog-forbidden-error-intercepted',
  imports: [Button, TranslateDirective, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  templateUrl: './dialog-forbidden-error-intercepted.component.html',
  styleUrl: './dialog-forbidden-error-intercepted.component.scss',
})
export class DialogForbiddenErrorInterceptedComponent implements OnDestroy {
  private authenticationService = inject(AuthenticationService);

  private ref: DynamicDialogRef = inject(DynamicDialogRef);
  private dialogService: DialogService = inject(DialogService);
  private readonly instance: DynamicDialogComponent | undefined;

  constructor() {
    this.instance = this.dialogService.getInstance(this.ref);
  }

  ngOnDestroy() {
    this.authenticationService.logout();
  }

  public close() {
    this.ref.close();
  }
}
